import React from "react";
import {
  Box,
  Button,
  Grid,
  Grid2,
  Paper,
  Rating,
  Typography,
} from "@mui/material";

import aboutUsBg from "../../../Images/aboutUsBg.jpg";
import wave from "../../../Images/wave.svg";
import celabrate from "../../../Images/celebrate.png";
import heart from "../../../Images/heart.png";
import clap from "../../../Images/clap.png";
import aboutUsAnimation from "../../../Images/aboutUsAnimation.json";
import { commonCss } from "../../../CssStyle/commonCss";
import Lottie from "lottie-react";
import AutoSlider from "./AutoSlider";
import { Navigate, useNavigate } from "react-router-dom";

const AboutUs = () => {
  const navigate=useNavigate()
  return (
    <Box >
       {/* <Box
              sx={{
                background: `url(${wave})`,
                backgroundSize: "cover",
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                zIndex: -1,
              }}
            ></Box> */}
      <Grid2
        container
        justifyContent={"center"}
        sx={{
          padding:  {xs:"1rem",md:"3rem 2rem"} ,
        
          background: `url(${aboutUsBg})`,
          backgroundSize: "cover",

        }}
      >
        <Box
          sx={{
            width: "100%",
            mt:{xs:"30%",sm:"25%",md:"20%",lg:"15%",xl:"5%"},
            maxWidth:{xs:"auto",xl:"2000px"},
            display: "flex",
            flexDirection: "column",
            gap: "2.5rem",
            pl: { xs: 0, md:"2rem",lg: "10rem" },
          }}
        >
          <Typography
            sx={{
              mt: "6%",
              fontSize: {xs:"1.5rem",md:"2rem",lg:"3.3rem"},
              width: "85%",
              fontWeight: 600,
              pl: { xs: "1rem", md: "2rem" },
              borderLeft: `7px solid ${commonCss.orange}`,
            }}
          >
            Our commitment is to drive{" "}
            <span style={{ color: commonCss.orange }}>innovation</span> and{" "}
            <span style={{ color: commonCss.orange }}>expansion</span> in your
            business!
          </Typography>
          <Typography sx={{ fontSize: "1.1rem", pl: "0.5rem" }}>
            Our mission as a software development company is to help your
            business thrive.
          </Typography>

          <Grid2 container size={{ xs: 12, md: 10,mt:{xs:"1rem",md:"2rem"} }} spacing={"2rem"} >
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  position: "relative",
                  padding: "2rem",
                  height: "100%",
                  width: "100%",
                  borderRadius: "10px",
                }}
              >
                <img
                  src={celabrate}
                  alt="4.5"
                  style={{
                    position: "absolute",
                    top:"-45px",
                    right: 0,
                    width: "80px",
                    left: "30px",
                  }}
                />
                <Box sx={{ mt: "2.5rem" }}>
                  <Rating
                    defaultValue={4.5}
                    precision={0.5}
                    readOnly
                    sx={{ fontSize: { xs: "2.5rem", md: "1.8rem" } }}
                  />
                </Box>
                <Typography sx={{ mt: "2rem", fontSize: "0.9rem" }}>
                  4.5-Star Client Satisfaction
                </Typography>
              </Paper>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  position: "relative",
                  padding: "2rem",
                  height: "100%",
                  width: "100%",
                  borderRadius: "10px",
                }}
              >
                <img
                  src={heart}
                  alt="4.5"
                  style={{
                    position: "absolute",
                    top: "-25px",
                    right: 0,
                    width: "80px",
                    left: "30px",
                  }}
                />
                <Typography
                  sx={{
                    mt: "2rem",
                    fontSize: "2.5rem",
                    fontWeight: 500,
                    color: commonCss.orange,
                  }}
                >
                  94%
                </Typography>
                <Typography sx={{ mt: "2rem", fontSize: "0.9rem" }}>
                  Returning Customers
                </Typography>
              </Paper>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Paper
                elevation={3}
                sx={{
                  position: "relative",
                  padding: "2rem",
                  height: "100%",
                  width: "100%",
                  borderRadius: "10px",
                }}
              >
                <img
                  src={clap}
                  alt="4.5"
                  style={{
                    position: "absolute",
                    top: "-25px",
                    right: 0,
                    width: "80px",
                    left: "30px",
                  }}
                />
                <Typography
                  sx={{
                    mt: "2rem",
                    fontSize: "2.5rem",
                    fontWeight: 500,
                    color: commonCss.orange,
                  }}
                >
                  90%
                </Typography>
                <Typography sx={{ mt: "2rem", fontSize: "0.9rem" }}>
                  Client-to-Client Referrals
                </Typography>
              </Paper>
            </Grid2>
          </Grid2>
        </Box>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
      <Grid2
        container
        spacing={"3rem"}
        sx={{ padding: { xs: "1rem", md: "4rem", },maxWidth:{xs:"auto",xl:"2000px"}, }}
      >
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Box sx={{}}>
            <Lottie animationData={aboutUsAnimation} loop={true} />
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "3rem",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                // fontWeight: 400,
                position: "relative",
                textAlign:{xs:"center",md:'left'},
                pb: "20px",
                "::before": {
                  content: '""',
                  position: "absolute",
                  // top: 0,
                  left: "30%",
                  bottom: 0,
                  width: "40%",
                  height: "3px",
                  backgroundColor: "transparent", // Make the background transparent
                  borderBottom: `3px dotted ${commonCss.orange}`, // Apply dotted border
                },
              }}
            >
              Who{" "}
              <span style={{ color: commonCss.blue, fontWeight: 600 }}>
                We Are?
              </span>
            </Typography>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
            >
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                What We Do for You?
              </Typography>
              <Typography sx={{ fontSize: "0.95rem", lineHeight: 1.8 }}>
                At Solver Thoughts, a Malaysian based software Development
                Company, Einstein's message is just not a quote, it is our
                gospel. Equipped with a highly professionally qualified team, we
                endeavor to transform today's imagination into tomorrow's
                innovation and arrive at software solutions that can take the
                market by storm. We cater to customers across the globe by
                offering zero-defect, cost-effective software solutions borne
                out of continuous research by extremely talented IT
                professionals in various domains
              </Typography>
            </Box>
          </Box>
        </Grid2>
      </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
      <Grid2
        container
        sx={{ padding: { xs: "0.5rem", md: "3rem 4rem" },maxWidth:{xs:"auto",xl:"2000px"}, }}
        spacing={"2rem"}
      >
        <Grid2 size={12}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 550,
              textAlign: "center",
              mt: "1rem",
              mb: "0.5rem",
            }}
          >
            Our Team
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "1.1rem",
              color: commonCss.gray,
              textAlign: "center",
            }}
          >
            A flawless combination of creativity and expertise
          </Typography>
        </Grid2>
        <Grid2 container size={12} sx={{ position: "relative" }}>
         
            <Box
              sx={{
               
                display: "flex",
                flexDirection: "column",
                position: "relative",
                pb: "20px",
                width:"fit-content",
                height: "fit-content",
                position: "absolute",
                zIndex: 50,
                left: {xs:"15%",md:"7%"},
                top: "50%",
                transform: "translatey(-50%)",
                textTransform: "uppercase",
                color: "white",
                letterSpacing: "0.175rem",
                
                
               
               
                "::before": {
                  content: '""',
                  position: "absolute",
                  // top: 0,
                  left: 2,
                  bottom: 0,
                  width: "20%",
                  height: "3px",
                  backgroundColor: "white", // Make the background transparent
                },
              }}
            >
              <Typography sx={{ fontSize: {xs:"1rem",md:"2rem"}, textTransform: "uppercase" }}>
                Visuals{" "}
              </Typography>
              <Typography
                sx={{
                  fontSize: {xs:"2rem",md:"3.5rem"},
                  textTransform: "uppercase",
                  fontWeight: 600,
                  mt: -2,
                }}
              >
                {" "}
                that capture{" "}
              </Typography>
              <Typography
                sx={{ fontSize: {xs:"1rem",md:"2rem"}, textTransform: "uppercase", mt: -2 }}
              >
                {" "}
                emotions
              </Typography>
            </Box>
       
          <Grid2 size={12}>
            <AutoSlider />
          </Grid2>
        </Grid2>
      </Grid2>
      </Grid2>
     
      <Grid2 container >
        <Grid2 container size={{ xs: 12, md: 6 }} justifyContent={"center"} p={{xs:'2rem',md:"4rem"}} sx={{backgroundColor:"#c5e0fc"}}>
          <Typography variant="h4" fontWeight={500} textAlign={"center"}>
            Transform your business with innovative software solutions!
          </Typography>
          <Button
            variant="outlined"
            sx={{
              borderColor: commonCss.buttonBg,
              color: commonCss.blue,
              padding: "0.5rem",
              textTransform: "none",
              width: {xs:"80%",lg:"40%"},
              fontWeight: 500,
              fontSize: "0.95rem",
              borderRadius: "30px",
              mt:"2rem",
              ":hover": {
                background: commonCss.blue,
              },
            }}
            onClick={()=>{navigate("/contactus")}}
          >
            Receive a custom estimate
          </Button>
        </Grid2>
        <Grid2 container size={{ xs: 12, md: 6 }} justifyContent={"center"} p={{xs:'2rem',md:"4rem"}} sx={{backgroundImage:`url(${aboutUsBg})`}}>
          <Typography variant="h4" fontWeight={500} textAlign={"center"}>
          Expand your workforce with our expert professionals!
          </Typography>
          <Button
            variant="outlined"
            sx={{
              borderColor: commonCss.buttonBg,
              color: commonCss.blue,
              padding: "0.5rem",
              textTransform: "none",
              width: {xs:"80%",lg:"40%"},
              fontWeight: 500,
              fontSize: "0.95rem",
              borderRadius: "30px",
              mt:"2rem",
              ":hover": {
                background: commonCss.blue,
              },
            }}
            onClick={()=>{navigate("/contactus")}}
          >
            Receive a custom estimate
          </Button>
        </Grid2>
      </Grid2>
      
    </Box>
  );
};

export default AboutUs;
